<template>
    <div :class="['block-method', 'popin-content']">
        <div class="block">
            <div
                class="close"
                @click="$emit('close')"
            >
                <IconPlus/> {{$t('cta.close')}}
            </div>
            <img
                class="main-image"
                :src="data.image.url"
                :alt="data.image.alt"
                :title="data.image.title"
                v-if="data.image"
            />
            <div
                class="caption"
                v-if="data.pictogram || data.imagecaption"
            >
                <p class="caption-text">{{data.imagecaption}}</p>
                <img
                    v-if="data.pictogram"
                    class="pictogram"
                    :src="data.pictogram.url"
                    :alt="data.pictogram.alt"
                    :title="data.pictogram.title"
                />
            </div>
            <div class="content" v-if="data.description || data.baseline">
                <h4>{{data.name}}</h4>
                <div class="baseline"
                    v-if="data.baseline"
                v-html="data.baseline"></div>
                <div class="baseline"
                    v-if="data.description"
                v-html="data.description"></div>
            </div>
        </div>
    </div>
</template>

<script>
import IconPlus from '@/components/IconPlus'
export default {
    components: {
        IconPlus
    },
    props: {
        data: {
            type: Object,
            default() {return {}}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.block-method
.block
    background-color: #ffffff
    margin: 0
    max-width: 925px
    width: 100%
    max-height: 90vh
    overflow: auto
.main-image
    width: 100%
    height: auto
    display: block
.pictogram
    width: 90px
    height: 90px
    display: inline-flex
.caption
    display: flex
    justify-content: flex-end
    padding-top: 10px
    padding-bottom: 10px
    padding-right: 8%
    padding-left: 8%
    &+.content
        border-top: 1px solid #e5e5e5
.caption-text
    font-size: 17px
    font-weight: 500
    flex: 1
h4
    font-size: 50px
    line-height: 1
    color: #ff2b2a
    font-weight: 500
    @include media-breakpoint-down($md)
        font-size: 36px
.baseline
    font-size: 28px
    color: #636772
    line-height: 1.4285714286
    margin-top: 1.2em
    /deep/ p
        font-size: inherit
        line-height: inherit
        letter-spacing: -.005em
    /deep/ ul
        padding-left: 1.2em
        list-style: disc
        li
            font-size: inherit
            line-height: inherit
    @include media-breakpoint-down($md)
        font-size: 17px

.content
    flex: 1
    padding: 8%
    overflow: auto
    p
        margin-top: 5.25%
.columns
    margin-top: 2.4em
    display: flex
    justify-content: space-between
    .column
        flex: .4625
svg
    width: 30px
    height: 30px
    transform: rotate(45deg)
    margin-right: .5em
    /deep/ path
        fill: #ff4a4a
.close
    color: #ff4a4a
    font-size: 20px
    font-weight: 500
    display: flex
    align-items: center
    align-self: baseline
    cursor: pointer
    justify-content: flex-end
    margin-bottom: 1em
    margin-top: 1em
    margin-right: 8%
</style>
